"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ValueChecker = /** @class */ (function () {
    function ValueChecker() {
    }
    ValueChecker.isBlank = function (value) {
        return (value === undefined ||
            value === null ||
            value === '' ||
            value.trim() === '');
    };
    ValueChecker.isPresent = function (value) {
        return !ValueChecker.isBlank(value);
    };
    ValueChecker.isBoolean = function (value) {
        var target = value.toString().toLowerCase();
        if (target === 'true') {
            return true;
        }
        else if (target === 'false') {
            return false;
        }
    };
    return ValueChecker;
}());
exports.default = ValueChecker;



//////////////////
// WEBPACK FOOTER
// ./common/src/utils/validation/value_checker.ts
// module id = ATID
// module chunks = 1